var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Functions = OCS.WxBriefing.Functions || {};
OCS.WxBriefing.Live = OCS.WxBriefing.Live || {};
OCS.WxBriefing.Functions.get_event_manager = function (ops) {
    if (!OCS.Live.OCSEventManager) {
        new OCS.Classes.OCSEventManager(ops);
    }
    return OCS.Live.OCSEventManager;
};
OCS.WxBriefing.Functions.get_about_manager = function (ops) {
    if (!OCS.WxBriefing.Live.AboutManager) {
        new OCS.WxBriefing.Classes.AboutManager(ops);
    }
    return OCS.WxBriefing.Live.AboutManager;
};
OCS.WxBriefing.Functions.get_alert_container = function (ops) {
    return new OCS.WxBriefing.Classes.AlertContainer(ops);
};
OCS.WxBriefing.Functions.get_console = function () {
    if (!OCS.WxBriefing.Live.Console) {
        OCS.console = new OCS.WxBriefing.Classes.Console();
        OCS.WxBriefing.Live.Console = OCS.console;
    }
    return OCS.WxBriefing.Live.Console;
};
OCS.WxBriefing.Functions.get_wx_briefing_controller = function () {
    if (!OCS.WxBriefing.Live.Controller) {
        OCS.WxBriefing.Functions.init_wx_briefing_controller();
    }
    return OCS.WxBriefing.Live.Controller;
};
OCS.WxBriefing.Functions.get_notice_manager = function (ops) {
    if (!OCS.WxBriefing.Live.NoticeManager) {
        new OCS.WxBriefing.Classes.NoticeManager(ops);
    }
    return OCS.WxBriefing.Live.NoticeManager;
};
OCS.WxBriefing.Functions.get_template_manager = function () {
    if (!OCS.Live.TemplateManager) {
        new OCS.Classes.TemplateManager();
    }
    return OCS.Live.TemplateManager;
};
OCS.WxBriefing.Functions.get_panel_manager = function (ops) {
    if (!OCS.WxBriefing.Live.PanelManager) {
        if (OCS.device.mobile) {
            new OCS.WxBriefing.Classes.PanelManagerMobile(ops);
        } else {
            new OCS.WxBriefing.Classes.PanelManager(ops);
        }
    }
    return OCS.WxBriefing.Live.PanelManager;
};
OCS.WxBriefing.Functions.get_preferences_manager = function (ops) {
    if (!OCS.WxBriefing.Live.PreferencesManager) {
        new OCS.WxBriefing.Classes.PreferencesManager(ops);
    }
    return OCS.WxBriefing.Live.PreferencesManager;
};
OCS.WxBriefing.Functions.get_preview_window = function (ops) {
    if (!OCS.WxBriefing.Live.PreviewWindow) {
        OCS.WxBriefing.Live.PreviewWindow = new OCS.WxBriefing.Classes.PreviewWindow(ops);
    }
    return OCS.WxBriefing.Live.PreviewWindow;
};
OCS.WxBriefing.Functions.get_product_manager = function (ops) {
    if (!OCS.WxBriefing.Live.ProductManager) {
        new OCS.WxBriefing.Classes.ProductManager(ops);
    }
    return OCS.WxBriefing.Live.ProductManager;
};
OCS.WxBriefing.Functions.get_search_manager = function (ops) {
    if (!OCS.WxBriefing.Live.SearchManager) {
        if (OCS.device.mobile) {
            new OCS.WxBriefing.Classes.SearchManagerMobile(ops);
        } else {
            new OCS.WxBriefing.Classes.SearchManager(ops);
        }
    }
    return OCS.WxBriefing.Live.SearchManager;
};
OCS.WxBriefing.Functions.get_ui = function (ops) {
    if (!OCS.WxBriefing.Live.UI) {
        OCS.WxBriefing.Functions.get_console();
        var ui_class = OCS.WxBriefing.Functions.define_ui_class();
        if (OCS.device.mobile) {
            ui_class = OCS.WxBriefing.Functions.define_ui_mobile_class(ui_class);
        }
        OCS.WxBriefing.Live.UI = new ui_class(ops);

    }
    return OCS.WxBriefing.Live.UI;
};
OCS.WxBriefing.Functions.get_ui_menu = function (ops) {
    if (!OCS.WxBriefing.Live.UI_Menu) {
        if (OCS.device.mobile) {
            new OCS.WxBriefing.Classes.UIMobileMenu(ops);
        } else {
            new OCS.WxBriefing.Classes.UIMenu(ops);
        }
    }
    return OCS.WxBriefing.Live.UI_Menu;
};
OCS.WxBriefing.Functions.get_url_manager = function () {
    if (!OCS.WxBriefing.Live.UrlManager) {
        new OCS.WxBriefing.Classes.UrlManager();
    }
    return OCS.WxBriefing.Live.UrlManager;
};
